export enum NewsActionType {
  SetState = 'STATUS.SET_STATE',
  GET_NEWS = 'STATUS.GET_NEWS',
  GET_NEWS_ITEM = 'STATUS.GET_NEWS_ITEM',
}
